import { connect } from 'react-redux';

import MessageList from '../MessagesList';

const mapStateToProps = state => ({
    attachments: state.attachments,
    users: state.users
});

export default connect(mapStateToProps)(MessageList);
